// Wellness score helpers — band, color, label.
export function bandFor(score) {
  if (score == null) return "empty";
  if (score < 4) return "critical";
  if (score < 6) return "improve";
  if (score < 7.5) return "acceptable";
  return "healthy";
}

export const BAND_COLORS = {
  critical: "#E07A5F",
  improve: "#F4A261",
  acceptable: "#E9C46A",
  healthy: "#2A9D8F",
  empty: "#C7BFAE",
};

export const BAND_LABELS = {
  critical: "Crítico",
  improve: "A mejorar",
  acceptable: "Aceptable",
  healthy: "Saludable",
  empty: "Sin datos",
};

// Contextual score labels for the user (point 9 of the spec).
export const CONTEXT_LABELS = {
  critical: "En riesgo",
  improve: "Necesita atención",
  acceptable: "Bueno",
  healthy: "Excelente",
  empty: "Sin datos",
};

export function contextLabelFor(score) {
  return CONTEXT_LABELS[bandFor(score)];
}

export const DIMENSION_LABELS = {
  sleep: "Sueño",
  physical: "Físico",
  mood: "Ánimo",
  thoughts: "Pensamientos",
  learning: "Aprendizaje",
};

export const DIMENSION_ORDER = ["sleep", "physical", "mood", "thoughts", "learning"];

export function formatScore(value) {
  if (value == null) return "—";
  return Number(value).toFixed(1);
}

export function formatDelta(delta) {
  if (delta == null) return null;
  const v = Number(delta);
  if (Math.abs(v) < 0.05) return "0.0";
  return (v > 0 ? "+" : "") + v.toFixed(1);
}

export const TIME_RANGES = [
  { id: "7", label: "7 días" },
  { id: "30", label: "30 días" },
  { id: "90", label: "90 días" },
  { id: "all", label: "Todo" },
];
